import {get, post} from "./axiosInstance";

export const apiRequestMemberLogin = (data: {username: string, password: string}) => {
  // return get("/mockData/login.json")
  return post("/member/login", data)
}

export const apiRequestGetMemberInfo = () => {
  // return get("/mockData/files.json")
  return get("/member/info")
}

export const apiRequestLibrary = (currentPage: number, postsPerPage: number) => {
  // return get("/mockData/eLibrary.json")
  return get(`/member/library?page=${currentPage + 1}&limit=${postsPerPage}`) // plus 1 here because it starts from 1
}

export const apiRequestDownloads = (currentPage: number, postsPerPage: number) => {
  // return get("/mockData/downloads.json")
  return get(`/member/downloads?page=${currentPage + 1}&limit=${postsPerPage}`) // plus 1 here because it starts from 1
}

export const apiRequestPostMemberForm = (formData: FormData) => {
  return post("/member/message", formData, true)
}